export default __webpack_public_path__ + "static/icons-plumbing-fd5e71071043d89f45914bf4300a8411.png";